module.exports = __webpack_public_path__ + "img/work5.acc22e95.png";